module.exports = __webpack_public_path__ + "static/media/Visanet.84e3088a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/Visanet.png
// module id = 540
// module chunks = 0